import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.stamping.comprobantes.data = {
      ...state.developer.stamping.comprobantes.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.developer.stamping.comprobantes.busy = true;
  });

  try {
    params = {
      ...params,
      limit: params.limit || store.state.developer.stamping.comprobantes.pagination.limit,
    };

    const response = await Http.get(`/app/audits/timbrado/comprobantes`, { params });

    store.setState((state) => {
      state.developer.stamping.comprobantes = {
        ...state.developer.stamping.comprobantes,
        busy: false,
        data: response.data,
        pagination: {
          ...state.developer.stamping.comprobantes.pagination,
          ...response.meta.pagination,
          limit: params.limit || state.developer.stamping.comprobantes.pagination.limit,
        },
        filters: {
          ...state.developer.stamping.comprobantes.filters,
          ...params,
          to: params.to,
          from: params.from,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.stamping.comprobantes.busy = false;
      state.developer.stamping.comprobantes.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.stamping.comprobantes = { ...initialState };
  });
};

const TimbradoComprobanteListStore = {
  state: () => initialState,
  actions: {
    change,
    paginate,
    reset,
  },
};

export default TimbradoComprobanteListStore;
